import m from "../../geodata/es2015/franceLow";
window.am4geodata_franceLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/franceLow.js
// module id = null
// module chunks = 